var _desc, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPosition4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10 by 10 orthogonal maze") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "10 by 10 orthogonal maze generated by The Maze Generator Website (https://www.mazegenerator.net/).")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 81.372,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 2,
    x2: 162,
    y2: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.251 17.999 L 98 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 18,
    x2: 146,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 34,
    x2: 130,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 34,
    x2: 162,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.024,
    y1: 66.031,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 50,
    x2: 146,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 66,
    x2: 114,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 66,
    x2: 162,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.856,
    y1: 81.972,
    x2: 66,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 82,
    x2: 98,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 82,
    x2: 146,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 98,
    x2: 82,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 98,
    x2: 114,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 98,
    x2: 146,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.934,
    y1: 113.94,
    x2: 34.027,
    y2: 114.008
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 114,
    x2: 98,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 130,
    x2: 82,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 130,
    x2: 162,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 146,
    x2: 66,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 146,
    x2: 146,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 162,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.274,
    y1: 162.065,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 2.226,
    y2: 145.068
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 50,
    x2: 18,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.096,
    y1: 97.669,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.957,
    y1: 130.903,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 18,
    x2: 34,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 34,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 114,
    x2: 34,
    y2: 146
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.931,
    y1: 18.04,
    x2: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 82,
    x2: 49.919,
    y2: 129.867
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 18,
    x2: 66,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 66,
    x2: 82,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 98,
    x2: 82,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 130,
    x2: 82,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 82,
    x2: 98,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 114,
    x2: 98,
    y2: 146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113.971 17.972 C 113.971 23.838 114.023 40.713 114.023 30.847"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 66,
    x2: 114,
    y2: 82
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 98,
    x2: 114,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 34,
    x2: 130,
    y2: 66
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 114,
    x2: 130,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 82,
    x2: 146,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.517,
    y1: 17.603,
    x2: 162,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.217,
    y1: 114.135,
    x2: 18,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.353,
    y1: 145.094,
    x2: 17.881,
    y2: 145.002
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 82,
    x2: 18.107,
    y2: 81.925
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.85,
    y1: 34.067,
    x2: 18,
    y2: 34
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03019, 0, 0, 0.028854, -0.346778, 143.257126)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 1412.571 -2508.557 C 1429.087 -2507.219 1443.394 -2519.49 1444.731 -2535.949 C 1446.01 -2552.407 1433.739 -2566.713 1417.223 -2568.109 C 1400.881 -2569.33 1386.459 -2557.059 1385.237 -2540.601 C 1383.841 -2524.259 1396.112 -2509.837 1412.57 -2508.557"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 1387.271 -2496.287 C 1393.145 -2500.416 1400.298 -2503.149 1408.265 -2502.451 C 1418.501 -2501.637 1426.875 -2495.298 1431.993 -2487.563 L 1462.118 -2427.837 L 1503.234 -2399.515 C 1506.723 -2396.84 1508.933 -2392.479 1508.468 -2387.709 C 1507.886 -2380.324 1501.431 -2374.798 1494.045 -2375.438 C 1491.777 -2375.555 1489.916 -2376.485 1487.88 -2377.416 L 1443.042 -2408.297 C 1441.647 -2409.402 1440.542 -2410.797 1439.611 -2412.251 L 1428.387 -2434.641 L 1414.837 -2375.089 L 1467.817 -2312.513 C 1469.038 -2310.594 1469.853 -2308.326 1470.318 -2306.058 L 1484.624 -2230.513 C 1484.508 -2228.827 1484.74 -2227.78 1484.624 -2226.442 C 1483.81 -2215.16 1474.04 -2207.018 1462.932 -2207.832 C 1453.685 -2208.588 1446.881 -2215.392 1444.729 -2223.825 L 1431.237 -2294.601 L 1388.143 -2341.707 L 1378.198 -2295.822 C 1377.849 -2293.67 1375 -2289.134 1374.185 -2287.331 L 1332.836 -2217.66 C 1328.765 -2211.321 1321.844 -2207.25 1313.994 -2207.89 C 1302.77 -2208.704 1294.454 -2218.474 1295.384 -2229.64 C 1295.617 -2232.781 1296.955 -2236.095 1298.118 -2238.364 L 1336.501 -2302.743 L 1368.545 -2444.643 L 1347.609 -2427.72 L 1336.501 -2377.182 C 1334.989 -2370.668 1329.115 -2365.376 1322.195 -2365.9 C 1314.693 -2366.481 1309.226 -2372.936 1309.808 -2380.439 C 1309.808 -2381.02 1309.924 -2381.602 1310.04 -2382.3 L 1323.183 -2441.212 C 1323.997 -2443.712 1325.335 -2445.98 1327.312 -2447.725 L 1387.271 -2496.285 L 1387.271 -2496.287 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition4);
export default __webpack_public_path__ + "static/media/Position4.6adedf336c124fbc67a155b04a84d7da.svg";
export { ForwardRef as ReactComponent };